import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/core/components/ui/card";
import { PieChart, Pie, Cell } from "recharts";
import { ChartContainer, ChartTooltip } from "@/core/components/ui/chart";
import { configs } from "../consts/configs";
import { useTranslation } from "react-i18next";
import { ReportViewerStatusAndCheckinProps } from "../types";

export function ReportViewerStatusAndCheckin({
  cancellationData,
  checkinData,
  totals,
}: ReportViewerStatusAndCheckinProps) {
  const [translate] = useTranslation(["insights"]);
  const totalReservations = totals.confirmed + totals.canceled;

  return (
    <Card className="border-secondary">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <span className="text-blue-600">⏰</span>
          {translate("report-viewer-status-and-checkin-title")}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-8">
          {/* Cancelamento */}
          <div>
            <h4 className="font-medium mb-4 text-center">
              {translate(
                "report-viewer-status-and-checkin-status-of-reservations",
              )}
            </h4>
            <div className="h-48">
              <ChartContainer config={configs} className="min-h-[200px] w-full">
                <PieChart>
                  <Pie
                    data={cancellationData}
                    cx="50%"
                    cy="50%"
                    innerRadius={40}
                    outerRadius={80}
                    dataKey="value"
                  >
                    {cancellationData.map((e, i) => (
                      <Cell key={`c-${i}`} fill={e.color} />
                    ))}
                  </Pie>
                  <ChartTooltip />
                </PieChart>
              </ChartContainer>
            </div>
            <div className="text-center">
              <p className="text-2xl font-bold">{totalReservations}</p>
              <p className="text-sm text-gray-600">
                {translate("report-viewer-status-and-checkin-total")}
              </p>
            </div>
            <Legend items={cancellationData} />
          </div>

          {/* Check-in */}
          <div>
            <h4 className="font-medium mb-4 text-center">
              {translate("report-viewer-status-and-checkin-check-in-realized")}
            </h4>
            <div className="h-48">
              <ChartContainer config={configs} className="min-h-[200px] w-full">
                <PieChart>
                  <Pie
                    data={checkinData}
                    cx="50%"
                    cy="50%"
                    innerRadius={40}
                    outerRadius={80}
                    dataKey="value"
                  >
                    {checkinData.map((e, i) => (
                      <Cell key={`k-${i}`} fill={e.color} />
                    ))}
                  </Pie>
                  <ChartTooltip />
                </PieChart>
              </ChartContainer>
            </div>
            <div className="text-center">
              <p className="text-2xl font-bold">
                {Math.round(totals.checkinTruePercent)}%
              </p>
              <p className="text-sm text-gray-600">
                {translate("report-viewer-status-and-checkin-check-in")}
              </p>
            </div>
            <Legend items={checkinData} />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

function Legend({
  items,
}: {
  items: Array<{ name: string; value: number; color: string }>;
}) {
  return (
    <div className="flex justify-center gap-4 mt-2">
      {items.map((it) => (
        <div key={it.name} className="flex items-center gap-1">
          <div
            className="w-3 h-3 rounded-full"
            style={{ background: it.color }}
          />
          <span className="text-xs">
            {it.name} ({Math.round(it.value)}%)
          </span>
        </div>
      ))}
    </div>
  );
}
